"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CloseButton = _interopRequireDefault(require("../CloseButton"));
var _link = require("../link");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A site-wide alert component that "sticks" to the top of the page.
 */
const AlertSite = _ref => {
  let {
    children,
    hasIcon,
    heading,
    link,
    onClose,
    show
  } = _ref;
  if (!show) return null;
  const hasLink = link !== null && Object.prototype.hasOwnProperty.call(link, 'href') && Object.prototype.hasOwnProperty.call(link, 'label');
  const {
    className: linkClassName = '',
    href = '',
    label = '',
    ...linkProps
  } = link || {};
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-alert-site",
    "data-blueprint-version": "6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alert-item"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, hasIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: "icon",
    role: "img",
    "aria-label": "info"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-info"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "body"
  }, heading && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, heading)), /*#__PURE__*/_react.default.createElement("p", {
    role: "alert"
  }, children, hasLink && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', /*#__PURE__*/_react.default.createElement("a", _extends({
    className: `link ${linkClassName}`,
    href: (0, _link.absolute)({
      url: href
    })
  }, linkProps), label)))), /*#__PURE__*/_react.default.createElement(_CloseButton.default, {
    onClose: onClose,
    size: "sm"
  }))));
};
var _default = exports.default = AlertSite;
AlertSite.propTypes = {
  /**
   * The content of the Alert: Site.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The Call To Action button. If `cta` is provided, the `icon`, `label`, and `onClick` props are required. Deprecated.
   */
  cta: _propTypes.default.any,
  /**
   * Is this Alert Site accompanied by an info icon?
   */
  hasIcon: _propTypes.default.bool,
  /**
   * The heading for the Alert Site.
   */
  heading: _propTypes.default.string,
  /**
   * The name of the icon in the design system. Deprecated.
   */
  icon: _propTypes.default.string,
  /**
   * The label and href of a hyperlink, appended to the message. Also supported: "rel", "target". If `link` is provided, the `href` and `label` props are required.
   */
  link: _propTypes.default.shape({
    href: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  }),
  /**
   * The event called when the component is dismissed.
   */
  onClose: _propTypes.default.func,
  /**
   * Show or hide the alert.
   */
  show: _propTypes.default.bool
};
AlertSite.defaultProps = {
  cta: null,
  hasIcon: false,
  heading: '',
  icon: null,
  link: null,
  show: true
};